import _toConsumableArray from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/defineProperty";
import React from 'react';
import classnames from 'classnames2';
import { Button } from '../../Button';
import { Header } from '../../Header';
import { Icon } from '../../Icon';
import styles from './ContentBlock.Header.scss';
export var ContentBlockHeader = function ContentBlockHeader(props) {
  var _props$headerAs = props.headerAs,
      headerAs = _props$headerAs === void 0 ? 'h2' : _props$headerAs;
  var expandButton = React.createElement("div", {
    className: styles.expandButton
  }, React.createElement(Button, {
    variant: "naked",
    size: "small",
    dataTest: "".concat(props.dataTest, "-expandCollapseButton"),
    onClick: props.onExpandClick
  }, props.isCollapsed ? React.createElement(Icon, {
    icon: "arrow-chevron-down"
  }) : React.createElement(Icon, {
    icon: "arrow-chevron-up"
  })));
  var tabChildren = props.tabs && React.Children.toArray(props.tabs.props.children);
  return React.createElement("div", {
    className: classnames(styles.contentBlockHeader, _defineProperty({}, styles.contentBlockCollapsed, props.isCollapsed))
  }, props.isCollapsible && expandButton, props.title && React.createElement("div", {
    className: styles.headerTitle
  }, React.createElement(Header, {
    as: headerAs,
    variant: "h3",
    dataTest: "contentBlockHeaderTitle"
  }, props.title)), props.tabs && React.createElement("div", {
    className: styles.headerChild
  }, React.cloneElement.apply(React, [props.tabs, {}].concat(_toConsumableArray(tabChildren.map(function (child, index) {
    return React.cloneElement(child, {
      onClick: function onClick() {
        return props.onTabSelect(index);
      },
      selected: props.selectedTabIndex === index
    });
  }))))), React.createElement("div", {
    className: classnames(styles.childContainer, props.alignContent === 'left' ? styles.alignLeft : styles.alignRight)
  }, props.children));
};
ContentBlockHeader.defaultProps = {
  alignContent: 'left'
};
ContentBlockHeader.displayName = 'ContentBlock.Header';